module.exports = __webpack_public_path__ + "img/mc_c.defce47e.png";